import { render, staticRenderFns } from "./multiFunctionalUpload.vue?vue&type=template&id=22cb96ba&"
import script from "./multiFunctionalUpload.vue?vue&type=script&lang=js&"
export * from "./multiFunctionalUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports